/** Keep a single pair of template delimiters, including when a picker is used inside {{ }}. */
export function normalizeAutomationCommentMessage(message: string): string {
  return message.replace(/\{{2,}\s*((?:custom|actor|card|workflow|stage|company|recipient)\.[\w.]+)\s*\}{2,}/g, '{{$1}}');
}
